import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const isSimulated = process.env.REACT_APP_SIMULATE === "true";

const authHeader = () => ({});

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Initiate a subscription for the given plan.
 * Sends an OTP to the provided phone number.
 * Returns: { subscribeRequestId }
 */
export const newSubscribe = async (phoneNumber) => {
  if (isSimulated) {
    await delay(800);
    return { data: { subscribeRequestId: "sim-request-001" } };
  }
  return axios.post(
    `${apiUrl}/subscription/initiate`,
    { phoneNumber },
    { headers: authHeader() },
  );
};

/**
 * Verify the OTP and complete the subscription.
 * Returns the created subscription object.
 */
export const verifySubscribe = async (subscribeRequestId, otp) => {
  console.log(
    "🚀 ~ verifySubscribe ~ subscribeRequestId, otp:",
    subscribeRequestId,
    otp,
  );

  if (isSimulated) {
    await delay(800);
    return { data: { success: true } };
  }
  return axios.patch(
    `${apiUrl}/subscription/subscribe`,
    { subscribeRequestId, otp },
    { headers: authHeader() },
  );
};
